import { globalConstants } from "../../constants/system/global.constans";

export function globals(
  state = {saveAreas:{}, isSaved: true, loadingAreas: {}, isLoading:false, headerHeight: 0, breadcrumbHeight: 0, showMenu:true },
  action
) {
  switch (action.type) {
    case globalConstants.SET_HEADER_HEIGHT:
      return { ...state, headerHeight: action.headerHeight };
    case globalConstants.SET_BREADCRUMB_HEIGHT:
      return { ...state, breadcrumbHeight: action.breadcrumbHeight };
    case globalConstants.SET_SAVE_STATUS:
          const{saveAreas} = state;
          let globalIsSaved = true;
          if(action.area)
          {
            saveAreas[action.area] = action.isSaved;
            for (const area in saveAreas) {
              if (saveAreas.hasOwnProperty(area)) {
                 if(!saveAreas[area]){
                   globalIsSaved= false;
                   break;
                 }
              }
            }
          }
          
          else if(action.isSaved === true){
            for (const area in saveAreas) {
              if (saveAreas.hasOwnProperty(area)) {
                 saveAreas[area] = true;
              }
            }
            globalIsSaved = action.isSaved;
          }
          else{
            saveAreas["unspecified"] = action.isSaved;
            for (const area in saveAreas) {
              if (saveAreas.hasOwnProperty(area)) {
                 if(!saveAreas[area]){
                   globalIsSaved= false;
                   break;
                 }
              }
            }
          }
      return { ...state, isSaved: globalIsSaved, saveAreas };

      case globalConstants.SET_IS_LOADING:
        const{loadingAreas} = state;
        let globalIsLoading = false;
        if(action.area)
        {
          loadingAreas[action.area] = action.isLoading;
          for (const area in loadingAreas) {
            if (loadingAreas.hasOwnProperty(area)) {
               if(loadingAreas[area] == true){
                globalIsLoading= true;
                 break;
               }
            }
          }
        }
        else if(action.isLoading === false){
          for (const area in loadingAreas) {
            if (loadingAreas.hasOwnProperty(area)) {
              loadingAreas[area] = false;
            }
          }
          globalIsLoading = action.isLoading;
        }
        else{
          loadingAreas["unspecified"] = action.isLoading;
          for (const area in loadingAreas) {
            if (loadingAreas.hasOwnProperty(area)) {
               if(loadingAreas[area] == true){
                globalIsLoading= true;
                 break;
               }
            }
          }
        }

    return { ...state, isLoading: globalIsLoading, loadingAreas };

    case globalConstants.SHOW_MENU:
      return {...state, showMenu:action.show};
    
    default:
      return state;
  }
}
